export default "__VITE_ASSET__Cr6$_SH$__"